import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { FinalStepsQuestionnaireItem } from './questionnaire'

export const DISCHARGE_FINAL_STEP_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [FinalStepsQuestionnaireItem.FINAL_STEPS_CURRENT_CERT_PERIOD]: QuestionnaireAnswerType.REFERENCE,
  [FinalStepsQuestionnaireItem.FINAL_STEPS_DISCHARGE_COMMUNICATION]: QuestionnaireAnswerType.STRING,
  [FinalStepsQuestionnaireItem.FINAL_STEPS_RESOURCES_PROVIDED]: QuestionnaireAnswerType.STRING,
  [FinalStepsQuestionnaireItem.FINAL_STEPS_CAREGIVER_RESPONSE]: QuestionnaireAnswerType.STRING,
  [FinalStepsQuestionnaireItem.FINAL_STEPS_DATE_PHYSICIAN_NOTIFIED]: QuestionnaireAnswerType.DATE,
  [FinalStepsQuestionnaireItem.FINAL_STEPS_DISCHARGE_NARRATIVE]: QuestionnaireAnswerType.STRING,
  [FinalStepsQuestionnaireItem.FINAL_STEPS_INTERNAL_NOTES]: QuestionnaireAnswerType.STRING
}
